import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";

import calendario1 from "assets/img/calendario-2023-i.jpg";
import calendario2 from "assets/img/calendario-2023-i-int.jpg";
import calendario3 from "assets/img/calendario-2023-ii.jpg";

class Calendario extends Component {
    state = {  }

    contenido = () => (
        <div id="calendario">
            <img src={calendario1} className="img img-responsive" alt="Calendario Académico"/>
            <img src={calendario2} className="img img-responsive" alt="Calendario Académico"/>
            <img src={calendario3} className="img img-responsive" alt="Calendario Académico"/>
        </div>
    )

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            /> 
        );
    }
}
 
export default Calendario;


// WEBPACK FOOTER //
// ./src/site/Componentes/Institucion/Contenido/Calendario.jsx